import { render, staticRenderFns } from "./closed-form.vue?vue&type=template&id=cc96e622&scoped=true"
import script from "./closed-form.vue?vue&type=script&lang=js"
export * from "./closed-form.vue?vue&type=script&lang=js"
import style0 from "./closed-form.vue?vue&type=style&index=0&id=cc96e622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc96e622",
  null
  
)

export default component.exports